import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetDefaultReportPrinter'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetDefaultReportPrinterStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetDefaultReportPrinterStore",
			variables: true,
		})
	}
}

export async function load_GetDefaultReportPrinter(params) {
  await initClient()

	const store = new GetDefaultReportPrinterStore()

	await store.fetch(params)

	return {
		GetDefaultReportPrinter: store,
	}
}
